<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'edit_log_list',
  extends: TablePage,
  data() {
    return {
      params: {},
      formConfig: {},
      modalConfig: {},
    };
  },
  props: {
    propsObj: Object,
  },
  async created() {
    this.params = { modelKey: this.propsObj.row.key_ };
    await this.getConfigList('edit_log_list');
  },
  methods: {},
};
</script>
